import { combineReducers } from 'redux';
import authReducer from './authReducer';
import appointmentReducer from './appointmentReducer';
import upcomingSessionReducer from './upcomingSessionReducer';
import franchiseReducer from './franchiseReducer';
import sessionReducer from './sessionReducer';
import userPreferencesReducer from './userPreferencesReducer';
import schoolsessionReducer from './schoolsessionReducer';
import familyAppointmentReducer from './familyAppointmentReducer';
import schoolAppointmentReducer from './schoolAppointmentReducer';
import familyPresetValuesReducer from './familyPresetValuesReducer';
import schoolPresetValuesReducer from './schoolPresetValuesReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  appointments: appointmentReducer,
  upcomingSessions: upcomingSessionReducer,
  franchise: franchiseReducer,
  session: sessionReducer,
  userPreferences: userPreferencesReducer,
  schoolsession : schoolsessionReducer,
  familyAppointment: familyAppointmentReducer,
  schoolAppointment: schoolAppointmentReducer,
  familyPresetValues: familyPresetValuesReducer,
  schoolPresetValues: schoolPresetValuesReducer






});

export default rootReducer;
